import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { apiError } from "@/lib/api";
import { toast } from "sonner";
import { ArrowRight } from "lucide-react";

const DEMO = [
  ["Commerçant", "commercant@demo.fr"],
  ["Mairie", "mairie@demo.fr"],
  ["Agent", "agent@demo.fr"],
  ["Fabricant", "paris@fab.demo"],
];

export default function Login() {
  const { login } = useAuth();
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [err, setErr] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setErr(""); setLoading(true);
    try {
      const u = await login(email, password);
      toast.success(`Bienvenue, ${u.name}`);
      nav("/app");
    } catch (e) {
      setErr(apiError(e));
    } finally { setLoading(false); }
  };

  const quick = (mail) => { setEmail(mail); setPassword("demo123"); };

  return (
    <div className="min-h-screen grid lg:grid-cols-2 bg-[#F4F4F5]">
      <div className="hidden lg:flex flex-col justify-between bg-[#000091] text-white p-12">
        <Link to="/" className="flex items-center gap-2">
          <div className="w-8 h-8 bg-white flex items-center justify-center"><span className="text-[#000091] font-black text-lg">E</span></div>
          <span className="font-display font-black text-xl">ENSEIGNE SMART</span>
        </Link>
        <div>
          <h1 className="font-display font-black text-4xl tracking-tighter leading-none mb-4">Votre espace professionnel</h1>
          <p className="text-white/70 max-w-md">Accédez à vos dossiers, instruisez les demandes, gérez vos devis ou contrôlez sur le terrain.</p>
        </div>
        <div className="text-xs text-white/40 uppercase tracking-[0.2em]">RGPD · Privacy by Design</div>
      </div>

      <div className="flex items-center justify-center p-6 lg:p-12">
        <div className="w-full max-w-md">
          <h2 className="font-display font-black text-3xl tracking-tight mb-2">Connexion</h2>
          <p className="text-slate-500 mb-8">Entrez vos identifiants pour continuer.</p>
          <form onSubmit={submit} className="space-y-4">
            <div>
              <label className="text-sm font-medium block mb-1">Email</label>
              <input data-testid="login-email" type="email" required value={email} onChange={(e) => setEmail(e.target.value)}
                className="w-full border border-input px-4 py-3 bg-white focus:ring-2 focus:ring-[#000091] outline-none" placeholder="vous@exemple.fr" />
            </div>
            <div>
              <label className="text-sm font-medium block mb-1">Mot de passe</label>
              <input data-testid="login-password" type="password" required value={password} onChange={(e) => setPassword(e.target.value)}
                className="w-full border border-input px-4 py-3 bg-white focus:ring-2 focus:ring-[#000091] outline-none" placeholder="••••••••" />
            </div>
            {err && <div data-testid="login-error" className="bg-red-50 border border-red-200 text-[#E1000F] px-4 py-2 text-sm">{err}</div>}
            <button data-testid="login-submit" disabled={loading}
              className="w-full bg-[#000091] text-white py-3 font-semibold hover:bg-blue-900 transition-colors flex items-center justify-center gap-2 disabled:opacity-60">
              {loading ? "Connexion..." : "Se connecter"} <ArrowRight size={18} />
            </button>
          </form>

          <div className="mt-6 border border-border bg-white p-4">
            <div className="text-xs uppercase tracking-[0.2em] text-slate-500 mb-3">Comptes de démonstration (mdp: demo123)</div>
            <div className="grid grid-cols-2 gap-2">
              {DEMO.map(([role, mail]) => (
                <button key={mail} type="button" onClick={() => quick(mail)} data-testid={`demo-${role.toLowerCase()}`}
                  className="text-left border border-border px-3 py-2 text-sm hover:border-[#000091] transition-colors">
                  <span className="font-semibold block">{role}</span>
                  <span className="text-xs text-slate-500">{mail}</span>
                </button>
              ))}
            </div>
          </div>

          <p className="text-sm text-slate-500 mt-6 text-center">
            Pas encore de compte ? <Link to="/register" className="text-[#000091] font-semibold hover:underline">Créer un compte</Link>
          </p>
        </div>
      </div>
    </div>
  );
}
